<template>
  <div class="section">
    <div class="section-title">
      <img :src="distributionTitlePic" alt="" />
    </div>
    <ul class="section-content" v-if="areaDataDistribution == 1 && areaDistributionResult.cityList">
      <li v-for="(item, index) in areaDistributionResult.cityList" :key="index">
        <span class="area">
          <i>{{ item.optionName }}</i>
        </span>
        <i class="line"></i>
        <span class="num">{{ item.num }}</span>
      </li>
    </ul>
    <ul class="section-content" v-if="areaDataDistribution == 2 && areaDistributionResult.districtList">
      <li v-for="(item, index) in areaDistributionResult.districtList" :key="index">
        <span class="area">
          <i>{{ item.optionName }}</i>
        </span>
        <i class="line"></i>
        <span class="num">{{ item.num }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    classN: {
      type: String,
      default: ""
    },
    areaDataDistribution: {
      type: Number,
      default: 0
    },
    distributionTitlePic: {
      type: String,
      default: null
    },
    areaDistributionResult: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.section {
  margin-top: 0.9rem;
  font-family: PingFangSC-Medium;
  &-title {
    text-align: center;
    margin: 0 -0.3rem 0.2rem;
    img {
      width: 100%;
    }
  }
  &-content {
    overflow: hidden;
    li {
      width: 23.5%;
      margin: 0 0 1.5% 1.5%;
      display: inline-block;
      background: rgba(255, 255, 255, 0.7);
      border-radius: 0.25rem;
      text-align: center;
      span {
        line-height: 0.8rem;
        display: block;
        i {
          display: inline-block;
          line-height: 0.3rem;
          vertical-align: middle;
          font-style: normal;
        }
      }
      .line {
        height: 0.5px;
        width: 90%;
        margin-left: 5%;
        display: block;
        background: rgba(0, 0, 0, 0.1);
      }
      .num {
        color: #333;
      }
    }
  }
}
.pc.section {
  margin-top: 64px;
  .section-title {
    img {
      width: 750px;
    }
    margin: 0 0 20px;
  }
  .section-content {
    li {
      width: 15%;
      margin: 0 0 1.5% 1.5%;
      border-radius: 20px;
      span {
        line-height: 52px;
        display: block;
        i {
          line-height: 20px;
        }
      }
      .line {
        height: 1px;
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }
}
</style>
